import React, { useEffect, useState } from 'react';
import { CheckCircle2, Clock, Download, ShieldCheck, Zap, BookOpen, Users, Star, ArrowRight, FileText, Layout, Video, ChevronLeft, ChevronRight } from 'lucide-react';
const MAIN_PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/1SkW4WMUthKBafSP3e6Jvi/kit_png_transpa.png';
const BONUS_1_IMG = 'https://cdn.magicpatterns.com/uploads/8UF4T8a8ux6w6a78rTjFbU/bonus_1.png';
const BONUS_2_IMG = 'https://cdn.magicpatterns.com/uploads/obxYyFAn4peC59MZRneAs5/bonus_2.png';
const BONUS_3_IMG = 'https://cdn.magicpatterns.com/uploads/jddnkDdhBkqj9GkoU6Ssmg/BONUS_EXCLUSIVO_3_.png';
const BONUS_4_IMG = 'https://cdn.magicpatterns.com/uploads/5jt623bYxcMZyVnZHwJX6P/BONUS_4.png';
const PREVIEW_IMGS = ['https://cdn.magicpatterns.com/uploads/mQoCLQv39go8F8N7DFfDLw/pag_.png', 'https://cdn.magicpatterns.com/uploads/rvJhfJkcwYyFkNLLxnTk3Z/pagina_1.png', 'https://cdn.magicpatterns.com/uploads/c5dhkTP2jMrSQEFhgWSim2/pagina_2.png', 'https://cdn.magicpatterns.com/uploads/mkRGZZZuZFjFCYvHXt5f6E/pg_2.png', 'https://cdn.magicpatterns.com/uploads/hafYeCk2rAAakNmWJX2BYm/pag_5.png', 'https://cdn.magicpatterns.com/uploads/k6c6PErk6GcDQstGp926Xh/pag_6.png', 'https://cdn.magicpatterns.com/uploads/8HWYPUE3sdmYuFmEv6yEWd/pag_7.png', 'https://cdn.magicpatterns.com/uploads/hcS3dY3KQ4YR1nhECrT2Aa/9.png', 'https://cdn.magicpatterns.com/uploads/7287RKYFwFxjNNd69QATda/Captura_de_pantalla_2026-02-21_131324.png'];
const CHECKOUT_NORMAL = 'https://checkout.kitspremium.online/checkouts/cn/hWN92aKvu32WPakv4eDR50Gw/es-ar?_r=AQABxBxhxzUem7lyXX1bfU9A9SgqXMw5Bdon3DYyPuBswYQ&preview_theme_id=138042802263';
const CHECKOUT_SUPER = 'https://checkout.kitspremium.online/checkouts/cn/hWN92aUEKISeP92VrOUYF2lm/es-ar?_r=AQABSuEoMGSMAvA3csqAhEluY5rqaDFxefntvTDEgVYmHDU&preview_theme_id=138042802263';
const STAR_COUNTS = [5, 5, 4, 5, 4];
export function SalesPage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 3
  });
  const [previewIdx, setPreviewIdx] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 0,
          minutes: 14,
          seconds: 0
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const prevPreview = () => setPreviewIdx(i => i === 0 ? PREVIEW_IMGS.length - 1 : i - 1);
  const nextPreview = () => setPreviewIdx(i => i === PREVIEW_IMGS.length - 1 ? 0 : i + 1);
  return <div className="w-full overflow-x-hidden bg-[#F8FAFC]" data-id="element-15">
      {/* Top Bar */}
      <div className="bg-[#1E3A8A] text-white text-center py-2 text-sm font-medium flex justify-center items-center gap-2 flex-wrap px-4" data-id="element-16">
        <Clock className="w-4 h-4" data-id="element-17" />
        <span data-id="element-18">
          OFERTA TERMINA EN: {String(timeLeft.hours).padStart(2, '0')}:
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>

      {/* Hero Section */}
      <header className="pt-6 pb-8 px-4 md:px-6 text-center max-w-5xl mx-auto" data-id="element-19">
        <div className="inline-flex items-center gap-2 text-[#1E3A8A] font-bold uppercase tracking-wider text-xs mb-3" data-id="element-20">
          <Users className="w-3 h-3" data-id="element-21" />
          Para Docentes de Comunicación y Oratoria
        </div>

        <h1 className="text-2xl md:text-3xl font-extrabold text-[#0F172A] mb-3 leading-tight max-w-3xl mx-auto" data-id="element-22">
          Organizá todo tu año de Comunicación y{' '}
          <span className="text-[#16A34A]" data-id="element-23">
            ahorrá hasta 12 meses de planificación
          </span>{' '}
          con el Mega Pack Oratoria Lista
        </h1>

        <div className="relative mx-auto mb-5 cursor-pointer" style={{
        maxWidth: '380px'
      }} onClick={scrollToPricing} data-id="element-24">
          <img src={MAIN_PRODUCT_IMG} alt="Megapack Comunicación y Oratoria" className="w-full h-auto drop-shadow-xl hover:scale-105 transition-transform duration-500" style={{
          maxHeight: '55vh',
          objectFit: 'contain'
        }} data-id="element-25" />
        </div>

        <p className="text-[#0F172A] text-sm max-w-xl mx-auto mb-5" data-id="element-26">
          Sistema completo de clases, actividades y proyectos de oratoria listos
          para usar. <strong data-id="element-27">Todo tu año resuelto (todos los niveles)</strong>
        </p>

        <button onClick={scrollToPricing} className="bg-[#16A34A] hover:bg-[#15803d] text-white text-lg font-bold py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 mx-auto w-full max-w-sm" data-id="element-28">
          <span data-id="element-29">👉</span> SÍ, QUIERO ACCESO INMEDIATO{' '}
          <ArrowRight className="w-5 h-5" data-id="element-30" />
        </button>

        <div className="flex flex-wrap justify-center gap-3 mt-4 text-xs text-gray-500" data-id="element-31">
          <span className="flex items-center gap-1" data-id="element-32">
            <ShieldCheck className="w-3 h-3" data-id="element-33" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-34">
            <Download className="w-3 h-3" data-id="element-35" /> Descarga inmediata
          </span>
          <span className="flex items-center gap-1" data-id="element-36">
            <CheckCircle2 className="w-3 h-3" data-id="element-37" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-38">
            <Users className="w-3 h-3" data-id="element-39" /> Acceso de por vida
          </span>
        </div>
      </header>

      {/* Pain Points */}
      <section className="bg-[#F8FAFC] py-12 px-4 border-t border-gray-100" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-42">
            Si enseñás Comunicación, esto te va a{' '}
            <span className="text-[#1E3A8A]" data-id="element-43">sonar familiar...</span>
          </h2>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-44">
            <p className="text-base text-[#0F172A] mb-4" data-id="element-45">
              Llegás del trabajo <strong data-id="element-46">agotado/a</strong> y tenés que
              planificar. Horas buscando proyectos, diseñando experiencias,
              armando evaluaciones...
            </p>
            <div className="bg-green-50 border-l-4 border-[#16A34A] p-4 rounded-r-lg" data-id="element-47">
              <p className="text-[#0F172A] font-medium" data-id="element-48">
                <strong data-id="element-49">No es falta de capacidad.</strong> Es que te falta un{' '}
                <strong data-id="element-50">sistema integral</strong> que te sostenga todo el año.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution */}
      <section className="py-12 px-4 text-center bg-white" data-id="element-51">
        <span className="bg-[#1E3A8A] text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-widest" data-id="element-52">
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A8A] mt-4 mb-3" data-id="element-53">
          MEGA PACK{' '}
          <span className="text-[#2563EB]" data-id="element-54">COMUNICACIÓN Y ORATORIA™</span>
        </h2>
        <p className="text-lg text-[#0F172A] mb-10" data-id="element-55">
          Sistema completo de proyectos, experiencias y evaluaciones{' '}
          <strong data-id="element-56">ya probadas en aula</strong>.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto" data-id="element-57">
          {[{
          icon: CheckCircle2,
          label: 'Listo'
        }, {
          icon: Zap,
          label: 'Probado'
        }, {
          icon: Layout,
          label: 'Organizado'
        }, {
          icon: Star,
          label: 'Usable'
        }].map((item, i) => <div key={i} className="bg-blue-50 p-5 rounded-xl flex flex-col items-center gap-2" data-id="element-58">
              <item.icon className="w-7 h-7 text-[#16A34A]" data-id="element-59" />
              <h3 className="font-bold text-[#16A34A] text-sm" data-id="element-60">{item.label}</h3>
            </div>)}
        </div>
      </section>

      {/* What's Included */}
      <section className="py-10 px-4 max-w-4xl mx-auto" data-id="element-61">
        <h3 className="text-2xl font-bold text-center mb-2" data-id="element-62">
          Lo que incluye el sistema
        </h3>
        <p className="text-center text-gray-500 text-sm mb-8" data-id="element-63">
          Todo organizado. Todo coherente. Todo aplicable.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-64">
          {[{
          icon: BookOpen,
          text: 'Programa completo de 6 años'
        }, {
          icon: CheckCircle2,
          text: 'Objetivos por nivel'
        }, {
          icon: Layout,
          text: 'Proyectos anuales listos'
        }, {
          icon: Star,
          text: 'Criterios de evaluación claros'
        }, {
          icon: FileText,
          text: 'Instrumentos listos para aplicar'
        }, {
          icon: CheckCircle2,
          text: 'Planillas y rúbricas'
        }, {
          icon: FileText,
          text: '200+ fichas editables'
        }, {
          icon: Zap,
          text: 'Estructura para feria escolar'
        }].map((item, i) => <div key={i} className="flex items-center gap-3 p-3 bg-white border border-gray-100 rounded-lg shadow-sm" data-id="element-65">
              <div className="bg-blue-50 p-2 rounded-lg shrink-0" data-id="element-66">
                <item.icon className="w-4 h-4 text-[#2563EB]" data-id="element-67" />
              </div>
              <span className="text-[#0F172A] font-medium text-sm" data-id="element-68">
                {item.text}
              </span>
            </div>)}
        </div>
      </section>

      {/* Preview Section */}
      <section className="bg-[#F8FAFC] py-12 px-4 border-t border-gray-100" data-id="element-69">
        <div className="text-center mb-8" data-id="element-70">
          <span className="bg-green-100 text-[#16A34A] px-4 py-1 rounded-full text-sm font-bold uppercase" data-id="element-71">
            Mirá por dentro
          </span>
          <h2 className="text-2xl font-bold text-[#1E3A8A] mt-3" data-id="element-72">
            <strong data-id="element-73">Páginas reales del</strong>{' '}
            <span className="text-[#2563EB]" data-id="element-74">material</span>
          </h2>
          <p className="text-gray-500 mt-1 text-sm" data-id="element-75">
            Proyectos paso a paso, clases listas y actividades prácticas
          </p>
        </div>

        <div className="max-w-3xl mx-auto relative" data-id="element-76">
          <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-200 cursor-pointer bg-white" onClick={scrollToPricing} data-id="element-77">
            <img src={PREVIEW_IMGS[previewIdx]} alt={`Página del material ${previewIdx + 1}`} className="w-full h-auto max-h-[500px] object-contain" data-id="element-78" />
          </div>

          <button onClick={prevPreview} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white border border-gray-200 shadow-md rounded-full p-2 hover:bg-gray-50 transition-colors" aria-label="Anterior" data-id="element-79">
            <ChevronLeft className="w-5 h-5 text-[#1E3A8A]" data-id="element-80" />
          </button>
          <button onClick={nextPreview} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white border border-gray-200 shadow-md rounded-full p-2 hover:bg-gray-50 transition-colors" aria-label="Siguiente" data-id="element-81">
            <ChevronRight className="w-5 h-5 text-[#1E3A8A]" data-id="element-82" />
          </button>

          <div className="flex justify-center gap-2 mt-4" data-id="element-83">
            {PREVIEW_IMGS.map((_, i) => <button key={i} onClick={() => setPreviewIdx(i)} className={`w-2.5 h-2.5 rounded-full transition-colors ${i === previewIdx ? 'bg-[#1E3A8A]' : 'bg-gray-300'}`} data-id="element-84" />)}
          </div>
        </div>
      </section>

      {/* Results Section */}
      <section className="py-12 px-4 bg-white" data-id="element-85">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-86">
          Resultados que <span className="text-[#16A34A]" data-id="element-87">transforman</span>
        </h2>
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6" data-id="element-88">
          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-[#2563EB]/20" data-id="element-89">
            <div className="flex items-center gap-3 mb-4" data-id="element-90">
              <div className="bg-[#1E3A8A] p-2 rounded-lg text-white" data-id="element-91">
                <Users className="w-5 h-5" data-id="element-92" />
              </div>
              <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-93">
                Para tus Estudiantes 🎓
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-94">
              {['Pierden el miedo a hablar en público', 'Argumentan con lógica y evidencia', 'Mejoran su expresión corporal', 'Participan activamente en clase'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-95">
                  <CheckCircle2 className="w-4 h-4 text-[#16A34A] shrink-0 mt-0.5" data-id="element-96" />
                  <span className="text-[#0F172A]" data-id="element-97">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-sm border-2 border-[#16A34A]/20" data-id="element-98">
            <div className="flex items-center gap-3 mb-4" data-id="element-99">
              <div className="bg-[#16A34A] p-2 rounded-lg text-white" data-id="element-100">
                <Star className="w-5 h-5" data-id="element-101" />
              </div>
              <h3 className="text-lg font-bold text-[#0F172A]" data-id="element-102">
                Para Vos como Docente 👩‍🏫
              </h3>
            </div>
            <ul className="space-y-2" data-id="element-103">
              {['Ahorrás horas de planificación semanal', 'Tenés rúbricas listas para evaluar', 'Clases dinámicas sin estrés', 'Reconocimiento de directivos y padres'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm" data-id="element-104">
                  <CheckCircle2 className="w-4 h-4 text-[#16A34A] shrink-0 mt-0.5" data-id="element-105" />
                  <span className="text-[#0F172A]" data-id="element-106">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-107">
          <button onClick={scrollToPricing} className="bg-[#16A34A] hover:bg-[#15803d] text-white text-lg font-bold py-3 px-10 rounded-full shadow-lg transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-108">
            <span data-id="element-109">👉</span> QUIERO LOGRARLO <ArrowRight className="w-5 h-5" data-id="element-110" />
          </button>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-14 px-4 bg-[#0F172A]" data-id="element-111">
        <div className="text-center mb-10" data-id="element-112">
          <span className="bg-yellow-500 text-black px-6 py-2 rounded-full text-sm font-black uppercase tracking-widest inline-flex items-center gap-2" data-id="element-113">
            🎁 BONOS GRATIS HOY
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-5" data-id="element-114">
            Te llevás <span className="text-[#2563EB]" data-id="element-115">4 bonos exclusivos</span>
          </h2>
          <p className="text-yellow-400 font-bold mt-2 text-base" data-id="element-116">
            ¡GRATIS por el día de hoy!
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-117">
          {[{
          img: BONUS_1_IMG,
          label: 'BONO 1',
          title: 'Banco de Rúbricas Defendibles (Editable)',
          desc: 'Un paquete de rúbricas listas para usar y adaptar. Evaluá con criterios claros y profesionales.'
        }, {
          img: BONUS_2_IMG,
          label: 'BONO 2',
          title: 'Plantillas de Informes de Desempeño',
          desc: 'Convertí tu evaluación en un documento formal y defendible. Plantillas editables.'
        }, {
          img: BONUS_3_IMG,
          label: 'BONO EXCLUSIVO 3',
          title: 'Banco de Proyectos + 5 Cuadernillos Técnicos',
          desc: 'Proyectos institucionales completos y cuadernillos técnicos aplicables en clase.'
        }, {
          img: BONUS_4_IMG,
          label: 'BONO 4',
          title: 'Calendario Estratégico de Implementación (12 Meses)',
          desc: 'No solo sabés qué enseñar. Sabés cuándo y cómo. Planificación anual lista para ejecutar.'
        }].map((bonus, i) => <div key={i} className="bg-white/5 border border-white/10 p-4 rounded-xl flex flex-col items-center cursor-pointer hover:bg-white/10 transition-colors" onClick={scrollToPricing} data-id="element-118">
              <div className="flex justify-between items-center w-full mb-3" data-id="element-119">
                <span className="bg-[#2563EB] text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-120">
                  {bonus.label}
                </span>
                <span className="bg-yellow-500 text-black text-xs font-black px-3 py-1 rounded-full" data-id="element-121">
                  🎁 GRATIS
                </span>
              </div>
              <img src={bonus.img} alt={bonus.title} className="w-full max-w-[240px] h-auto rounded-lg mb-3 shadow-lg" data-id="element-122" />
              <h3 className="font-bold text-base text-white text-center mb-1" data-id="element-123">
                {bonus.title}
              </h3>
              <p className="text-xs text-gray-400 text-center" data-id="element-124">{bonus.desc}</p>
            </div>)}
        </div>
      </section>

      {/* Pricing Section */}
      <section id="compra" className="py-14 px-4 bg-[#F8FAFC]" data-id="element-125">
        <div className="max-w-2xl mx-auto" data-id="element-126">
          <div className="bg-[#1E3A8A] text-white text-center py-3 rounded-t-xl font-bold flex justify-center items-center gap-2" data-id="element-127">
            <Clock className="w-5 h-5" data-id="element-128" /> ⚡ OFERTA ESPECIAL POR TIEMPO LIMITADO
          </div>

          <div className="bg-white text-[#0F172A] rounded-b-xl shadow-2xl overflow-hidden border border-gray-200 p-8 relative" data-id="element-129">
            <div className="text-center mb-6" data-id="element-130">
              <h3 className="text-2xl font-black text-[#1E3A8A] mb-1" data-id="element-131">
                MEGAPACK COMPLETO
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-132">
                Comunicación + Oratoria + Todo incluido
              </p>
            </div>

            <div className="flex justify-center mb-6" data-id="element-133">
              <img src={MAIN_PRODUCT_IMG} alt="Megapack Completo" className="w-56 h-auto drop-shadow-2xl" data-id="element-134" />
            </div>

            <div className="space-y-2 mb-6 max-w-xs mx-auto" data-id="element-135">
              {['Pack Completo de Comunicación y Oratoria', 'Soporte Prioritario', 'Actualizaciones 2026', 'Garantía Extendida', '4 Bonos incluidos GRATIS'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm" data-id="element-136">
                  <CheckCircle2 className="w-4 h-4 text-[#16A34A] shrink-0" data-id="element-137" />
                  <span className="text-[#0F172A]" data-id="element-138">{item}</span>
                </div>)}
            </div>

            <div className="text-center mb-6" data-id="element-139">
              <p className="text-gray-400 line-through font-bold text-lg" data-id="element-140">
                Precio regular: $49.990
              </p>
              <div className="flex justify-center items-baseline gap-1 mt-1" data-id="element-141">
                <span className="text-5xl font-black text-[#16A34A]" data-id="element-142">
                  $19.990
                </span>
                <span className="text-gray-500 text-lg" data-id="element-143">ARS</span>
              </div>
              <p className="text-xs text-gray-400 mt-1 font-bold" data-id="element-144">
                Pago único · Acceso inmediato
              </p>
            </div>

            <a href={CHECKOUT_SUPER} target="_blank" rel="noopener noreferrer" className="block w-full bg-[#16A34A] hover:bg-[#15803d] text-white text-xl font-black py-4 rounded-lg shadow-lg text-center transition-all transform hover:-translate-y-1 mb-3" data-id="element-145">
              ✅ SÍ, QUIERO EL MEGAPACK →
            </a>

            <div className="flex justify-center items-center gap-3 text-gray-400 text-xs" data-id="element-146">
              <span data-id="element-147">Métodos de pago seguros:</span>
              <span className="font-bold text-gray-600" data-id="element-148">VISA</span>
              <span className="font-bold text-gray-600" data-id="element-149">Mastercard</span>
              <span className="font-bold text-gray-600" data-id="element-150">MercadoPago</span>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-10 px-4 bg-white" data-id="element-151">
        <div className="max-w-3xl mx-auto bg-[#F8FAFC] border border-blue-100 rounded-xl p-6 flex flex-col md:flex-row items-center gap-5" data-id="element-152">
          <div className="bg-[#1E3A8A] p-4 rounded-full text-white shrink-0" data-id="element-153">
            <ShieldCheck className="w-9 h-9" data-id="element-154" />
          </div>
          <div data-id="element-155">
            <h3 className="text-lg font-bold text-[#1E3A8A] mb-1" data-id="element-156">
              🛡️ Garantía de Satisfacción Total
            </h3>
            <p className="text-[#0F172A] text-sm" data-id="element-157">
              Probalo <strong data-id="element-158">7 días</strong>. Si no cumple tus expectativas, te
              devolvemos el <strong data-id="element-159">100%</strong> de tu dinero. Sin preguntas,
              sin letra chica. Compra 100% protegida.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-14 px-4 bg-[#F8FAFC]" data-id="element-160">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-10" data-id="element-161">
          Testimonios de Docentes
        </h2>
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-162">
          {[{
          name: 'María José G.',
          role: 'Docente de Secundaria · Buenos Aires',
          stars: 5,
          text: 'Jamás pensé que iba a organizar todo el año tan rápido. El material es increíble, las fichas son claras y los proyectos están listos para llevar al aula. ¡Lo recomiendo a todas mis colegas!'
        }, {
          name: 'Claudia R.',
          role: 'Profesora de Lengua · Córdoba',
          stars: 5,
          text: 'Mis alumnos mejoraron muchísimo su expresión oral. Las clases son más dinámicas y se nota que los chicos disfrutan participar. El sistema funciona de verdad.'
        }, {
          name: 'Sebastián M.',
          role: 'Docente de Comunicación · Rosario',
          stars: 4,
          text: 'Como docente de Comunicación, siempre me costó encontrar material de calidad. Este megapack me ahorró meses de trabajo. Los proyectos son excelentes y muy completos.'
        }, {
          name: 'Valeria T.',
          role: 'Profesora de Oratoria · Mendoza',
          stars: 5,
          text: 'Compré el Megapack y fue la mejor inversión del año. Tengo todo organizado, mis clases mejoraron notablemente y mis alumnos están más comprometidos.'
        }, {
          name: 'Diego F.',
          role: 'Docente · La Plata',
          stars: 4,
          text: 'Excelente material. Lo apliqué desde el primer día y los resultados fueron inmediatos. Los chicos participan más y yo perdí menos tiempo preparando. Vale cada peso.'
        }].map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-163">
              <div className="flex mb-3" data-id="element-164">
                {[...Array(5)].map((_, j) => <Star key={j} className={`w-4 h-4 ${j < t.stars ? 'fill-current text-yellow-400' : 'text-gray-200 fill-current'}`} data-id="element-165" />)}
              </div>
              <p className="text-[#0F172A] italic text-sm mb-4" data-id="element-166">"{t.text}"</p>
              <div data-id="element-167">
                <p className="font-bold text-[#0F172A] text-sm" data-id="element-168">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-169">{t.role}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 px-4 max-w-3xl mx-auto" data-id="element-170">
        <h2 className="text-2xl font-bold text-center text-[#1E3A8A] mb-8" data-id="element-171">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-3" data-id="element-172">
          {[{
          q: '¿En qué formato recibo el material?',
          a: '100% digital: PDF descargables listos para usar e imprimir.'
        }, {
          q: '¿Puedo imprimir los cuadernillos?',
          a: 'Sí, sin restricciones. Podés imprimir las copias que necesites para tus alumnos.'
        }, {
          q: '¿Para qué niveles sirve?',
          a: 'Principalmente para Nivel Secundario (Ciclo Básico y Orientado) y Talleres de Oratoria.'
        }, {
          q: '¿Cuánto tarda en llegar?',
          a: 'Acceso inmediato tras la compra. Te llega un email con el link de descarga.'
        }, {
          q: '¿Sirve para otros países?',
          a: 'Sí, los conceptos de oratoria y comunicación son universales, aunque está pensado con el currículo argentino en mente.'
        }].map((item, i) => <div key={i} className="bg-white p-5 rounded-lg border border-gray-100 shadow-sm" data-id="element-173">
              <div className="flex items-start gap-3" data-id="element-174">
                <div className="bg-[#1E3A8A] text-white w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold shrink-0 mt-0.5" data-id="element-175">
                  ?
                </div>
                <div data-id="element-176">
                  <h4 className="font-bold text-[#0F172A] mb-1 text-sm" data-id="element-177">
                    {item.q}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-178">{item.a}</p>
                </div>
              </div>
            </div>)}
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-[#1E3A8A] text-white text-center" data-id="element-179">
        <div className="max-w-4xl mx-auto" data-id="element-180">
          <h2 className="text-2xl md:text-4xl font-extrabold mb-4" data-id="element-181">
            ¿Listo/a para transformar tu año escolar?
          </h2>
          <p className="text-lg text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-182">
            Uníte a cientos de docentes que ya organizaron su año sin estrés.
          </p>
          <button onClick={scrollToPricing} className="bg-[#16A34A] hover:bg-[#15803d] text-white text-lg md:text-xl font-bold py-4 px-10 rounded-full shadow-xl transition-all transform hover:-translate-y-1 inline-flex items-center gap-2" data-id="element-183">
            <span data-id="element-184">✅</span> QUIERO EMPEZAR AHORA{' '}
            <ArrowRight className="w-5 h-5" data-id="element-185" />
          </button>
          <p className="mt-5 text-blue-200 text-sm" data-id="element-186">
            MEGA PACK COMUNICACIÓN Y ORATORIA™
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0F172A] text-gray-400 py-10 px-4 text-center text-sm" data-id="element-187">
        <div className="max-w-4xl mx-auto" data-id="element-188">
          <div className="flex items-center justify-center gap-2 mb-3 text-white font-bold" data-id="element-189">
            <Zap className="w-4 h-4" data-id="element-190" /> MEGA PACK COMUNICACIÓN Y ORATORIA™
          </div>
          <p className="mb-3" data-id="element-191">
            © 2026 Mega Pack Comunicación. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6" data-id="element-192">
            <a href="#" className="hover:text-white" data-id="element-193">
              Términos
            </a>
            <a href="#" className="hover:text-white" data-id="element-194">
              Privacidad
            </a>
            <a href="#" className="hover:text-white" data-id="element-195">
              Soporte
            </a>
          </div>
        </div>
      </footer>
    </div>;
}